import { z } from "zod";
import { PRODUCT_TYPES } from "../constants/domain";
import { paginationQuerySchema } from "./pagination";

export const ARTICLES_PAGE_SIZE = 9;
const SEARCH_MAX_LENGTH = 100;

export const productListQuerySchema = z.object({
  type: z.enum(PRODUCT_TYPES).optional(),
});
export type ProductListQuery = z.infer<typeof productListQuerySchema>;

export const articleListQuerySchema = paginationQuerySchema.extend({
  limit: z.coerce.number().int().min(1).max(50).default(ARTICLES_PAGE_SIZE),
  search: z.string().trim().max(SEARCH_MAX_LENGTH).optional(),
  tag: z.string().trim().max(SEARCH_MAX_LENGTH).optional(),
});
export type ArticleListQuery = z.infer<typeof articleListQuerySchema>;

export const slugParamSchema = z.object({
  slug: z
    .string()
    .min(1)
    .max(200)
    .regex(/^[a-z0-9-]+$/i),
});
